import { opus } from './../api/opus';
import { claims } from './../api/claims';
import { bankid } from './../api/bankid';
import { settings } from './../settings';
import { tools } from './../helpers/tools';
import { dom } from './../helpers/dom';
import { configuration } from '../api/configuration';
import { Patient, Listing, Booking, BookingReschedule, BookingCancel, ListingInfo } from '../api/models';

class MyPages {
    constructor(underscore, hd) {
        this._ = underscore;
        this.hd = hd;
        this.config = null;
        this.timeSlots = null;
        this.bookings = null;
        this.listing = new Listing();
        this.booking = new Booking();
        this.bookingReschedule = new BookingReschedule();
        this.bookingCancel = new BookingCancel();
        this.lastBooking = null;
    }

    init(newSettings) {
        const self = this;
        self.hd.opus = opus;

        settings.init(newSettings);
        opus.init();

        configuration
            .get()
            .then((config) => {
                self.config = config.result;

                settings.daterange.maxSpan.days = self.config.maxDaysInDateRangeSelection;
                settings.daterange.startDate = new Date();
                settings.daterange.endDate = tools.addDaysToNow(self.config.maxDaysInDateRangeSelection);

                return opus.getClinics();
            })
            .then(() => {
                claims
                    .get()
                    .then((claim) => {
                        $('.hd-mp-section').hide();
                        $('#hd-mp-logon').toggle(!claim);
                        $('#hd-mp-booking').toggle(claim);
                        $('.hd-mp-sidebar').css('visibility', claim ? 'visible' : 'hidden');

                        if (claim) {
                            if (self.booking.patient.personalNumberAsString != claim.result.personalNumberAsString) {
                                self.booking.patient = new Patient(
                                    claim.result.personalNumberAsString,
                                    claim.result.givenName,
                                    claim.result.familyName
                                );
                            }

                            self.load();
                        }
                    })
                    .catch((response) => {
                        tools.handleError(self, response);

                        $('.hd-mp-section').hide();
                        $('#hd-mp-logon').show();
                        $('.hd-mp-sidebar').css('visibility', 'hidden');
                    });
            })
            .catch((response) => {
                $('.hd-mp-section').hide();
                $('#hd-mp-loading').show();

                tools.handleError(self, response, $('#hd-mp-loading-error'));
            });

        $('body').addClass('sidebar-primary');
        $('#hd-mp-logon-ssn').val(self.booking.patient.personalNumberAsString);
        $('#hd-mp-list-email').val(self.booking.patient.email);
        $('#hd-mp-list-phone').val(self.booking.patient.phone);

        $('#hd-mp-nav-booking')
            .off('click')
            .on('click', function (e) {
                self.navigate(e, $(this), '#hd-mp-booking');

                tools.trackView('bokningar', $('#hd-mp-booking h1').first().text());
            });

        $('#hd-mp-nav-list')
            .off('click')
            .on('click', function (e) {
                self.navigate(e, $(this), '#hd-mp-list');

                tools.trackView('lista', $('#hd-mp-list h1').first().text());
            });

        $('#hd-mp-nav-health')
            .off('click')
            .on('click', function (e) {
                self.navigate(e, $(this), '#hd-mp-health');

                tools.trackView('health', $('#hd-mp-health h1').first().text());
            });

        $('#hd-mp-nav-logout')
            .off('click')
            .on('click', function () {
                claims
                    .destroy()
                    .then(() => {
                        $('.hd-mp-section').hide();
                        $('#hd-mp-logon-status').hide();
                        $('#hd-mp-logon').show();
                        $('.hd-mp-sidebar').css('visibility', 'hidden');
                    })
                    .catch((response) => {
                        tools.handleError(self, response, $('#hd-mp-logon-error'));
                    });
            });

        const form = $('#hd-mp-list-form'),
            child = $('#hd-mp-list-child'),
            childadd = $('#hd-mp-list-child-add'),
            family = $('#hd-mp-list-family'),
            familyadd = $('#hd-mp-list-family-add');

        $('a', childadd)
            .off('click')
            .on('click', function (e) {
                e.preventDefault();

                const el = $('#hd-mp-list-child > div').clone();

                $('input', el).val('');

                $('#hd-mp-list-child').append(el);
            });

        $('a', familyadd)
            .off('click')
            .on('click', function (e) {
                e.preventDefault();

                const el = $('#hd-mp-list-family > div').clone();

                $('input', el).val('');

                $('#hd-mp-list-family').append(el);
            });

        $('#hd-mp-list-select')
            .off('change')
            .on('change', function () {
                $('#hd-info-list-sent').hide();

                self.listing.relation = $(this).val();
                self.listing.children = [];
                self.listing.other = [];

                family.hide(200);
                child.hide(200);
                childadd.hide(200);
                familyadd.hide(200);

                switch (self.listing.relation) {
                    case '1':
                        form.show(200);
                        break;

                    case '2':
                        form.show(200);
                        child.show(200);
                        childadd.show(200);
                        break;

                    case '3':
                        form.show(200);
                        family.show(200);
                        familyadd.show(200);
                        break;

                    default:
                        form.hide(200);
                        break;
                }
            });

        $('#hd-mp-list-confirm')
            .off('click')
            .on('click', function () {
                self.list();
            });
    }

    load() {
        const self = this;
        const appointments = $('#hd-mp-booking-rows'),
            template = self._.template($('#tmpl-hd-mp-booking-appointment').html()),
            readonly = self._.template($('#tmpl-hd-mp-booking-readonly').html());

        self.hd.views.healthDeclaration.load();

        tools.trackView('bokningar', $('#hd-mp-booking h1').first().text());

        $('#hd-filter-daterange').daterangepicker(settings.daterange, (start, end) => {
            settings.daterange.startDate = start.toDate();
            settings.daterange.endDate = end.toDate();

            $('#hd-filter-clinicians').trigger('change');
        });

        $('#hd-mp-list-clinic').html(`<option value="">${settings.resources.select}</option>`);

        for (let i = 0; i < opus.clinics.length; i++) {
            const clinic = opus.clinics[i];

            $('#hd-mp-list-clinic').append(
                `<option value="${clinic.id}">${clinic.name}, ${tools.toTitleCase(clinic.city)}</option>`
            );
        }

        opus.getBookings()
            .then((response) => {
                let hasbooking = false;

                self.bookings = response.result;
                self.lastBooking = response.result.length > 0 ? response.result[response.result.length - 1] : null;

                appointments.html('');
                response.result.forEach((appointment) => {
                    appointment.timeSlot.clinic = tools.findByValue(opus.clinics, 'id', appointment.timeSlot.clinicId);
                    appointment.timeSlot.clinician = tools.findByValue(
                        appointment.timeSlot.clinic.clinicians,
                        'id',
                        +appointment.timeSlot.clinicianId
                    );

                    if (!tools.isInPast(appointment.timeSlot.start)) {
                        hasbooking = true;
                        if (tools.isWithinNHours(appointment.timeSlot.start, self.config.canRescheduleAndCancelWithin)) {
                            appointments.append(readonly(appointment));
                        } else {
                            appointments.append(template(appointment));
                        }
                    }
                });

                if (self.lastBooking && settings.settings.regions) {
                    settings.settings.regions.forEach((region) => {
                        const clinic = tools.findByValue(region.clinics, 'id', self.lastBooking.timeSlot.clinic.id);

                        if (clinic) {
                            self.lastBooking;
                            self.lastBooking.timeSlot.clinic = $.extend(self.lastBooking.timeSlot.clinic, clinic);
                        }
                    });
                }

                $('#hd-mp-booking-noappointments').toggle(!hasbooking);

                if (self.lastBooking && self.lastBooking.timeSlot && self.lastBooking.timeSlot.clinic) {
                    const path = $('#hd-mp-nav-book').data('path');
                    $('.hd-mp-nav-book').attr('href', `${path}${self.lastBooking.timeSlot.clinic.path}`);
                }
            })
            .catch((response) => {
                tools.handleError(self, response, $('#hd-mp-booking-error'));

                appointments.html('');
            });
    }

    navigate(e, item, id) {
        if (e) e.preventDefault();

        $('#nav-submenu li.page_item').removeClass('active');

        $('.hd-mp-section').hide();

        $(id).show();

        item.parent().addClass('active');
    }

    getTimeSlots(booking) {
        const self = this;
        const clinicianId = $('#hd-filter-clinicians').val();
        const container = $('#hd-time-rows'),
            template = self._.template($('#tmpl-hd-time-row').html());

        container.html('<div id="hd-placeholder-rows" class="loader-gif"><img src="/wp-content/themes/happident/resources/assets/images/Happi-spin.gif"/></div>').show();

        $('#hd-mp-notimeslots').hide();

        opus.getTimeSlotsForDateRange(
            booking.timeSlot.clinicId,
            settings.daterange.startDate,
            settings.daterange.endDate,
            booking.timeSlot.treatmentId,
            booking.timeSlot.treatment.duration,
            clinicianId
        )
            .then((response) => {
                self.timeSlots = response.result;

                const timeSlots = self.timeSlots.filter((timeSlot) => {
                    return (
                        timeSlot.treatmentId == booking.timeSlot.treatmentId &&
                        tools.isTimeEqualLength(timeSlot.start, timeSlot.end, booking.timeSlot.start, booking.timeSlot.end)
                    );
                });

                container.html('');
                if (timeSlots.length === 0) {
                    $('#hd-mp-notimeslots').show();
                } else {
                    $('#hd-mp-notimeslots').hide();

                    timeSlots.forEach((timeSlot) => {
                        timeSlot.clinic = tools.findByValue(opus.clinics, 'id', timeSlot.clinicId);
                        timeSlot.clinician = tools.findByValue(opus.clinicians, 'id', +timeSlot.clinicianId);
                        container.append(template(timeSlot));
                    });
                }
            })
            .catch((response) => {
                tools.handleError(self, response, $('#hd-mp-reschedule-error'));
            });
    }

    selectTimeSlot(id, clinicId, start) {
        const self = this;

        self.bookingReschedule.timeSlot = opus.findTimeSlot(self.timeSlots, id, clinicId, start);
        dom.apply(self.bookingReschedule.timeSlot);

        $('#hd-mp-reschedule').hide();

        $('#hd-mp-reschedule-confirm').show();

        $('#hd-mp-booking .hd-info, #hd-mp-booking .hd-error').hide();
    }

    rescheduleBooking(id) {
        const self = this;
        const booking = tools.findByValue(self.bookings, 'id', id);

        self.bookingReschedule.originalBookingId = id;
        self.bookingReschedule.timeSlot = booking.timeSlot;
        self.bookingReschedule.patient = booking.patient;

        opus.getTreatments().then(() => {
            booking.timeSlot.treatment = tools.findByValue(opus.treatments, 'id', booking.timeSlot.treatmentId);
            self.bookingReschedule.timeSlot.treatment = booking.timeSlot.treatment;

            tools.trackView(
                'omboka',
                $('#hd-mp-reschedule h1').first().text(),
                booking.timeSlot.clinic,
                booking.timeSlot.treatment
            );
            dom.apply(booking.timeSlot, booking.timeSlot.clinic, booking.timeSlot.clinician, booking.timeSlot.treatment);

            $('#hd-mp-booking').hide();

            $('#hd-mp-reschedule').show();

            $('#hd-time-rows').html('<div id="hd-placeholder-rows" class="loader-gif"><img src="/wp-content/themes/happident/resources/assets/images/Happi-spin.gif"/></div>');

            $('#hd-filter-clinicians').prop('disabled', 'disabled').html(`<option value="">${settings.resources.all}</option>`);

            $('#hd-filter-clinicians')
                .off('change')
                .on('change', () => {
                    self.getTimeSlots(booking);
                });

            opus.getClinicians(booking.timeSlot.clinicId, booking.timeSlot.treatmentId)
                .then(() => {
                    for (let i = 0; i < opus.clinicians.length; i++) {
                        const clinician = opus.clinicians[i];

                        if (clinician.isActive) {
                            $('#hd-filter-clinicians').append(
                                `<option value="${clinician.id}">${clinician.name}, ${clinician.title}</option>`
                            );
                        }
                    }

                    $('#hd-filter-clinicians').prop('disabled', false).trigger('change');
                })
                .catch((response) => {
                    tools.handleError(self, response, $('#hd-mp-reschedule-error'));
                });
        });
    }

    cancelBooking(id) {
        const self = this;

        self.bookingCancel.booking = tools.findByValue(self.bookings, 'id', +id);

        opus.getTreatments()
            .then(() => {
                tools.trackView(
                    'avboka',
                    $('#hd-mp-cancel-confirm h1').first().text(),
                    self.bookingCancel.booking.timeSlot.clinic,
                    self.bookingCancel.booking.timeSlot.treatment
                );

                dom.apply(
                    self.bookingCancel.booking.timeSlot,
                    self.bookingCancel.booking.timeSlot.clinic,
                    self.bookingCancel.booking.timeSlot.clinician,
                    self.bookingCancel.booking.timeSlot.treatment
                );
            })
            .catch((response) => {
                tools.handleError(self, response, $('#hd-mp-cancel-confirm-error'));
            });

        $('#hd-mp-booking').hide();

        $('#hd-mp-cancel-confirm').show();
    }

    cancel() {
        $('.hd-mp-section, #hd-mp-booking .hd-info, #hd-mp-booking .hd-error').hide();

        $('#hd-mp-booking').show();
    }

    confirmCancelBooking() {
        const self = this;

        dom.toggleSpinner('#hd-mp-cancel-confirm-btn', true);

        $('#hd-mp-booking .hd-info, #hd-mp-booking .hd-error').hide();

        opus.cancelBooking(self.bookingCancel.booking.id, self.bookingCancel.booking.timeSlot.clinicId)
            .then(() => {
                tools.trackEvent('booking-cancelled');

                $(`#hd-mp-booking-appointment-row-${self.bookingCancel.booking.id}`).remove();

                $('#hd-info-cancelled').show();
            })
            .catch((response) => {
                tools.handleError(self, response, $('#hd-mp-booking-error'));

                dom.apply(
                    self.bookingCancel.booking.timeSlot,
                    self.bookingCancel.booking.timeSlot.clinic,
                    self.bookingCancel.booking.timeSlot.clinician,
                    self.bookingCancel.booking.timeSlot.treatment
                );

                $(`#hd-mp-booking-appointment-row-${self.bookingCancel.booking.id} .hd-mp-col-btn>div>div`).show();

                $(`#hd-mp-booking-appointment-row-${self.bookingCancel.booking.id} .hd-mp-col-btn .spinner-border`).hide();
            })
            .finally(() => {
                dom.toggleSpinner('#hd-mp-cancel-confirm-btn');

                self.load();
                self.navigate(null, $('#hd-mp-nav-booking'), '#hd-mp-booking');
            });
    }

    confirmRescheduleBooking() {
        const self = this;

        dom.toggleSpinner('#hd-mp-reschedule-confirm-btn', true);

        $('#hd-mp-booking .hd-info, #hd-mp-booking .hd-error').hide();

        opus.rescheduleBooking(self.bookingReschedule)
            .then(() => {
                tools.trackEvent('booking-rescheduled');

                $('#hd-info-rescheduled').show();
            })
            .catch((response) => {
                tools.handleError(self, response, $('#hd-mp-booking-error'));

                dom.apply(
                    self.bookingReschedule.timeSlot,
                    self.bookingReschedule.timeSlot.clinic,
                    self.bookingReschedule.timeSlot.clinician,
                    self.bookingReschedule.timeSlot.treatment
                );
            })
            .finally(() => {
                dom.toggleSpinner('#hd-mp-reschedule-confirm-btn');

                self.load();
                self.navigate(null, $('#hd-mp-nav-booking'), '#hd-mp-booking');
            });
    }

    list() {
        const self = this;

        $('#hd-mp-list .hd-error, #hd-mp-list .hd-info').hide();

        self.listing.clinic.id = $('#hd-mp-list-clinic').val();
        self.listing.personalNumber = self.booking.patient.personalNumberAsString;
        self.listing.firstName = self.booking.patient.firstName;
        self.listing.lastName = self.booking.patient.lastName;
        self.listing.email = $('#hd-mp-list-email').val();
        self.listing.mobilePhoneNumber = $('#hd-mp-list-phone').val();

        if (
            self.listing.personalNumber.length < 1 ||
            self.listing.email.length < 1 ||
            self.listing.mobilePhoneNumber.length < 1 ||
            self.listing.clinic.id.length < 1
        ) {
            $('#hd-mp-list-mandatory-err').show();

            return false;
        }

        let valid = true;

        self.listing.children = [];
        self.listing.other = [];
        self.listing.clinic = tools.findByValue(opus.clinics, 'id', self.listing.clinic.id);

        if (self.listing.relation != '1') {
            $(`#hd-mp-list-${self.listing.relation == '2' ? 'child' : 'family'} input`).each(function () {
                const pnr = $(this).val();

                if (pnr) {
                    valid = valid & tools.validatePersonalNumber(pnr);

                    if (valid) {
                        (self.listing.relation == '2' ? self.listing.children : self.listing.other).push(pnr);
                    } else {
                        $('#hd-mp-list-ssn-err').show();
                    }
                }
            });
        }

        if (!tools.validatePersonalNumber(self.listing.personalNumber)) {
            $('#hd-mp-list-ssn-err').show();

            valid = false;
        }

        if (!tools.validateEmail(self.listing.email)) {
            $('#hd-mp-list-email-err').show();

            valid = false;
        }

        if (!tools.validatePhone(self.listing.mobilePhoneNumber)) {
            $('#hd-mp-list-phone-err').show();

            valid = false;
        }

        if (valid) {
            const list = new ListingInfo();

            list.patientEmail = self.listing.email;
            list.clinicId = self.listing.clinic.id;
            list.clinicMessageSubject = self._.template($('#tmpl-hd-listing-clinic-subject').html())(self.listing);
            list.clinicMessageBody = self._.template($('#tmpl-hd-listing-clinic-text').html())(self.listing).replace(
                /\r?\n/g,
                '\r\n'
            );
            list.patientMessageSubject = self._.template($('#tmpl-hd-listing-patient-subject').html())(self.listing);
            list.patientMessageBody = self._.template($('#tmpl-hd-listing-patient-text').html())(self.listing).replace(
                /\r?\n/g,
                '\r\n'
            );

            dom.apply(null, self.listing.clinic);
            dom.toggleSpinner('#hd-mp-list-confirm', true);

            opus.sendListing(list)
                .then(() => {
                    tools.trackEvent('list', self.listing.clinic.name);

                    $('#hd-info-list-sent').show(200);

                    $('#hd-mp-list-form').hide();
                })
                .catch((response) => {
                    tools.handleError(self, response, $('#hd-mp-list-error'));
                })
                .finally(() => {
                    dom.toggleSpinner('#hd-mp-list-confirm');
                });
        }
    }

    login() {
        const self = this;
        const personalNumber = $('#hd-mp-logon-ssn').val();
        const valid = tools.validatePersonalNumber(personalNumber);

        if (valid) {
            $('#hd-mp-logon-ssn-err').hide();
            $('#hd-mp-logon-login .spinner-border').show();
            $('#hd-mp-logon-login-dologin').hide();
            $('#hd-mp-logon-login-loggingin').show();
            $('#hd-mp-logon-login').addClass('disabled');

            tools.trackEvent('bankid-login-started');

            bankid
                .auth(personalNumber, (collect) => {
                    if (collect.code) {
                        $('#hd-mp-logon-status').text(collect.message).removeClass('hd-error').show();
                    }
                })
                .then((auth) => {
                    const user = auth.result.response.completionData.user;

                    tools.trackEvent('bankid-login-done');

                    if (self.booking.patient.personalNumberAsString != user.personalNumber) {
                        self.booking.patient = new Patient(user.personalNumber, user.givenName, user.surname);
                    }

                    $('.hd-mp-section').hide();
                    $('#hd-mp-logon').hide();
                    $('#hd-mp-booking').show();
                    $('.hd-mp-sidebar').css('visibility', 'visible');

                    self.load();
                })
                .catch((auth) => {
                    if (!auth.code == 'userCancel') {
                        tools.handleError(self, auth, $('#hd-mp-logon-error'));
                    }

                    $('.hd-mp-section').hide();
                    $('#hd-mp-logon').show();
                    $('.hd-mp-sidebar').css('visibility', 'hidden');
                })
                .finally(() => {
                    $('#hd-mp-logon-login .spinner-border').hide();
                    $('#hd-mp-logon-login-dologin').show();
                    $('#hd-mp-logon-login-loggingin').hide();
                    $('#hd-mp-logon-login').removeClass('disabled');
                });
        } else {
            $('#hd-mp-logon-ssn-err').show(200);
        }
    }
}

(function (hd, _) {
    hd.views = hd.views || {};
    hd.views.mypages = new MyPages(_, hd);
    // eslint-disable-next-line no-undef
})((window.hd = window.hd || {}), _);



// WEBPACK FOOTER //
// ./scripts/booking/views/mypages.js